/**
 * Farmec - GuestWishlist Query
 *
 * Maps the guestWishlistMoveToCart GraphQL mutation.
 *
 * Expected input:
 *   cartItems: Array of objects (CartItemGuestInput)
 *      e.g., {
 *        sku: "2612",
 *        product_type: "simple",
 *        quantity: 1,
 *        product_option: {
 *          extension_attributes: {}
 *        }
 *      }
 *   guestCartId: String
 */

import { Field } from 'Util/Query';
import { GUEST_QUOTE_ID } from 'Store/Cart/Cart.dispatcher';
import BrowserDatabase from 'Util/BrowserDatabase';
import { isSignedIn } from 'Util/Auth';

export class GuestWishlistQuery {
    /**
     * Returns a GraphQL field for moving guest wishlist items to cart.
     *
     * @param {Array} cartItems - Array of CartItemGuestInput objects.
     * @param {String} guestCartId - The guest cart ID.
     * @returns {Field} The GraphQL field for the mutation.
     */
    getMoveToCartMutation(cartItems, guestCartId) {
        // Automatically fetch guestCartId from browser storage if not provided and user is a guest.
        if (!guestCartId && !isSignedIn()) {
            guestCartId = BrowserDatabase.getItem(GUEST_QUOTE_ID);
        }

        return new Field('guestWishlistMoveToCart')
            .addArgument('wishlistItems', '[CartItemGuestInput!]!', cartItems)
            .addArgument('guestCartId', 'String!', guestCartId)
            .addFieldList([
                'success',
                'message'
            ]);
    }
}

export default new GuestWishlistQuery();
